import React from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import { globalizationPath, useGlobal } from '@rcg/ui-react';
import useStyles from './index.style';

const Footer = () => {
  const classes = useStyles();
  const GLOBALS = useGlobal();
  const { market, lang } = GLOBALS.data;
  const { renderContent } = useGlobal();
  const urlPath = globalizationPath(market, lang, '');

  return (
    <footer className={classes.root}>
      <Typography className="footer-copyright" color="textSecondary" component="div">
        {`© ${new Date().getFullYear()} ${renderContent(
          'royalCaribbeanInternational',
          'Royal Caribbean International',
        )}`}
      </Typography>
      <Box className="link-container">
        <Typography component="div">
          <Link
            href={`${urlPath}${renderContent('stateroomBookingAmendPrivacyPath', '/privacy')}`}
            target="_blank"
            rel="noopener">
            {renderContent('stateroomBookingAmendPrivacy', 'Privacy')}
          </Link>
          <Link
            href={`${urlPath}${renderContent(
              'stateroomBookingAmendLegalPath',
              '/terms-and-conditions/digital-terms-of-use-and-end-user-license-agreement',
            )}`}
            target="_blank"
            rel="noopener">
            {renderContent('stateroomBookingAmendLegal', 'Legal')}
          </Link>
        </Typography>
      </Box>
    </footer>
  );
};

export default Footer;
